export const Types = {
  REQUEST: "creditCard/REQUEST",
  ERROR: "creditCard/ERROR",
  SUCCESS: "creditCard/SUCCESS"
};

const INITIAL_STATE = {
  loading: false,
  holder_name: null,
  registry_code: null,
  card_expiration: null,
  card_number: null,
  card_cvv: null,
  campaign_id: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.REQUEST:
      return { loading: true };
    case Types.ERROR:
    case Types.SUCCESS:
      return { loading: false };
    default:
      return state;
  }
};

export const Creators = {
  subscription: ({
    holder_name,
    registry_code,
    card_expiration,
    card_number,
    card_cvv,
    newCard,
    campaign_id,
    reCode
  }) => ({
    type: Types.REQUEST,
    payload: {
      credit_card: {
        holder_name,
        registry_code,
        card_expiration,
        card_number,
        card_cvv,
        newCard,
        campaign_id
      },
      "g-recaptcha-response": reCode
    }
  }),
  creditCardError: () => ({ type: Types.ERROR }),
  creditCardSuccess: () => ({ type: Types.SUCCESS })
};



// WEBPACK FOOTER //
// ./src/store/ducks/creditCard.js